import template from './eventAddPage.html';
import controller from './eventAddPage.controller';
import './eventAddPage.scss';

let eventAddPageComponent = {
  restrict: 'E',
  bindings: {
    locations: '<'
  },
  template,
  controller
};

export default eventAddPageComponent;
